const TOOLS = {
  compoundInterestCalculator: {
    name: "Compound Interest Calculator",
    path: "/compound-interst-calc",
  },
};

const EXAMPLES = {
  compoundInterestCalculatorCompare: {
    name: "Compare Compound Interest",
    path: "/compound-interst-calc-compare-mint-mike",
  },
};

export { TOOLS, EXAMPLES };
